"use client"
import { useState, useEffect } from "react"
import axios from "axios"
import ConfirmationDialog from "../components/ConfirmationDialog"
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ProductList = () => {
  const [products, setProducts] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false)
  const [editingProduct, setEditingProduct] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false)
  const [productToDelete, setProductToDelete] = useState(null)
  const [searchTerm, setSearchTerm] = useState("")
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)
  const [isViewDialogOpen, setIsViewDialogOpen] = useState(false)
  const [viewProduct, setViewProduct] = useState(null)
  const [successMessage, setSuccessMessage] = useState("");
  const [vendorSearch, setVendorSearch] = useState("");

  const [previewImage, setPreviewImage] = useState(null)

  // CATEGORY & MATERIAL STATES
  const [categories, setCategories] = useState([])
  const [materials, setMaterials] = useState([])
  const [filteredCategories, setFilteredCategories] = useState([])
  const [filteredMaterials, setFilteredMaterials] = useState([])
  const [showCategoryDropdown, setShowCategoryDropdown] = useState(false)
  const [showMaterialDropdown, setShowMaterialDropdown] = useState(false)

  // vendor assign
  const [isAssignDialogOpen, setIsAssignDialogOpen] = useState(false)
  const [selectedProductForVendor, setSelectedProductForVendor] = useState(null)
  const [vendors, setVendors] = useState([])
  const [filteredVendors, setFilteredVendors] = useState([])
  const [showVendorDropdown, setShowVendorDropdown] = useState(false)
  const [selectedVendorEmail, setSelectedVendorEmail] = useState("")



  // PRODUCT STATUS STATES
  const [statusList, setStatusList] = useState([]);
  const [filteredStatusList, setFilteredStatusList] = useState([]);
  const [showStatusDropdown, setShowStatusDropdown] = useState(false);

  useEffect(() => {
    fetchProducts()
    fetchCategories()
    fetchMaterials()
    fetchVendors()
    fetchStatusList();

  }, [])
  const fetchStatusList = async () => {
    try {
      const res = await axios.get(
        `https://logicx.premierlam.com/api/get-pixel-product-status`,
        { headers: { authorization: localStorage.getItem("accessToken") } }
      );
      setStatusList(res.data.data);
      setFilteredStatusList(res.data.data);
    } catch (err) {
      if (err.response?.status === 401)
        setError("Token expired. Please login again.");
    }
  };

  const fetchVendors = async () => {
    try {
      const res = await axios.get(
        `https://logicx.premierlam.com/api/pixel-get-all-vendor-email-name`,
        { headers: { authorization: localStorage.getItem("accessToken") } }
      )
      setVendors(res.data.data)
      setFilteredVendors(res.data.data)
    } catch (err) {
      if (err.response?.status === 401) {
        setError("Token expired. Please login again.")
        setVendors([])
      }
    }
  }


  const fetchProducts = async () => {
    try {
      setIsLoading(true)
      const res = await axios.get(`https://logicx.premierlam.com/api/get-pixel-products`, {
        headers: { authorization: localStorage.getItem("accessToken") }
      })
      setProducts(res.data.data || [])
    } catch {
      setError("Failed to fetch products")
    } finally {
      setIsLoading(false)
    }
  }

  const fetchCategories = async () => {
    try {
      const res = await axios.get(
        `https://logicx.premierlam.com/api/pixel-get-product-categories`,
        { headers: { authorization: localStorage.getItem("accessToken") } }
      )
      setCategories(res.data.data)
      setFilteredCategories(res.data.data)
    } catch (err) {
      if (err.response?.status === 401) setError("Token expired. Please login again.")
    }
  }

  const fetchMaterials = async () => {
    try {
      const res = await axios.get(
        `https://logicx.premierlam.com/api/pixel-get-product-material`,
        { headers: { authorization: localStorage.getItem("accessToken") } }
      )
      setMaterials(res.data.data)
      setFilteredMaterials(res.data.data)
    } catch (err) {
      if (err.response?.status === 401) setError("Token expired. Please login again.")
    }
  }


  const handleEditClick = (p) => {
    setEditingProduct(p)
    setIsEditDialogOpen(true)
  }

  const handleEditProduct = async (e) => {
    e.preventDefault();

    try {
      setIsSubmitting(true);
      const formData = new FormData();

      formData.append("product_code", editingProduct.product_code);
      formData.append("product_name", editingProduct.product_name);
      formData.append("category_name", editingProduct.category_name);
      formData.append("product_material", editingProduct.product_material);
      formData.append("product_description", editingProduct.product_description);
      formData.append("product_cost_price", editingProduct.product_cost_price);
      formData.append("product_selling_price", editingProduct.product_selling_price);
      formData.append("product_status", editingProduct.product_status);

      // FIX ✔
      if (editingProduct.newImage) {
        formData.append("image", editingProduct.newImage);     // new image
      } else {
        formData.append("existing_image", editingProduct.product_image); // old image path
      }

      await axios.put(
        `https://logicx.premierlam.com/api/pixel-edit-product/${editingProduct.id}`,
        formData,
        {
          headers: {
            authorization: localStorage.getItem("accessToken"),
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success("Product updated successfully!", {
        position: "top-right",
        autoClose: 2500,
      });

      setIsEditDialogOpen(false);
      setTimeout(() => setSuccessMessage(""), 2000);
      fetchProducts();

    } catch (error) {
      console.error(error.response?.data);
      toast.error("Product update failed!", {
        position: "top-right",
        autoClose: 2500,
      });

      setTimeout(() => setSuccessMessage(""), 2000);
    } finally {
      setIsSubmitting(false);
    }
  };


  const handleDeleteClick = (p) => {
    setProductToDelete(p)
    setIsDeleteDialogOpen(true)
  }

  const handleDeleteProduct = async () => {
    try {
      await axios.delete(
        `https://logicx.premierlam.com/api/pixel-delete-product/${productToDelete.id}`,
        { headers: { authorization: localStorage.getItem("accessToken") } }
      )
      fetchProducts()
      setIsDeleteDialogOpen(false)
    } catch {
      setError("Failed to delete product")
    }
  }

  const filteredProducts = products.filter(
    (p) =>
      p.product_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      p.product_code.toLowerCase().includes(searchTerm.toLowerCase()) ||
      p.category_name.toLowerCase().includes(searchTerm.toLowerCase())
  )

  const totalPages = Math.ceil(filteredProducts.length / rowsPerPage)
  const paginatedProducts = filteredProducts.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  )

  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" })

  const handleAssignVendor = async () => {
    if (!selectedVendorEmail) return alert("Please select vendor")

    try {
      await axios.post(
        `https://logicx.premierlam.com/api/assign-vendor-to-product`,
        {
          product_code: selectedProductForVendor.product_code,
          vendor_email: selectedVendorEmail,
        },
        {
          headers: {
            authorization: localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        }
      )

      toast.success("Vendor assigned successfully!", {
        position: "top-right",
        autoClose: 2500,
      });

      setIsAssignDialogOpen(false)
      setSelectedVendorEmail("")
      fetchProducts()
    } catch (err) {
      console.error(err.response?.data)
      toast.error("Failed to assign vendor!", {
        position: "top-right",
        autoClose: 2500,
      });

    }
  }
  const truncateWords = (text, limit = 10) => {
    if (!text) return "";
    const words = text.trim().split(/\s+/);
    return words.length <= limit
      ? text
      : words.slice(0, limit).join(" ") + " ...";
  };
  const updateProductStatus = async (product_code, newStatus) => {
    try {
      await axios.post(
        "https://logicx.premierlam.com/api/update-pixel-product-status",
        {
          product_status: newStatus,
          product_code: product_code,
        },
        {
          headers: {
            authorization: localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Product status updated!", {
        position: "top-right",
        autoClose: 2000,
      });

      fetchProducts(); // refresh table
    } catch (err) {
      toast.error("Failed to update status", {
        position: "top-right",
        autoClose: 2000,
      });
    }
  };


  return (
    <><ToastContainer />

      <div className="p-4 bg-gray-50 min-h-screen">
        <div className="max-w-7xl mx-auto">
          <div className="flex justify-between items-start mb-6">
            <div>
              <h1 className="text-2xl font-semibold text-gray-900 mb-1">Products</h1>
              <p className="text-gray-500">Manage your products</p>
            </div>

            <button
              onClick={() => (window.location.href = "/add-product")}
              className="flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg transition-colors"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
              </svg>
              Add Product
            </button>
          </div>

          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none w-64 mb-4"
            />
            {successMessage && (
              <div className="mb-3 p-3 bg-green-100 border border-green-300 rounded text-green-700 font-medium">
                {successMessage}
              </div>
            )}

            {/* TABLE */}
            <div className="overflow-x-auto">
              {isLoading ? (
                <div className="text-center py-6 text-gray-500">Loading...</div>
              ) : (
                <table className="w-full border-collapse">
                  <thead>
                    <tr className="border-b border-gray-200 text-gray-600 text-sm">
                      <th className="py-3 px-4 text-left">Image</th>
                      <th className="py-3 px-4 text-left">Code</th>
                      <th className="py-3 px-4 text-left">Name</th>
                      <th className="py-3 px-4 text-left">Category</th>
                      <th className="py-3 px-4 text-left">Material</th>
                      <th className="py-3 px-4 text-left">Vendor</th>
                      <th className="py-3 px-4 text-left">Status</th>

                      <th className="py-3 px-4 text-left">Cost Price</th>
                      <th className="py-3 px-4 text-left">Selling Price</th>
                      <th className="py-3 px-4 text-left min-w-[250px]">Description</th>
                      <th className="py-3 px-4 text-left">Added By</th>
                      <th className="py-3 px-4 text-left">Created</th>
                      <th className="py-3 px-4 text-left">Assign Vendor</th>

                      <th className="py-3 px-4 text-left">Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    {paginatedProducts.map((p) => (
                      <tr key={p.id} className="border-b hover:bg-gray-50">
                        <td className="py-3 px-4">
                          <img
                            src={p.product_image}
                            className="w-12 h-12 rounded cursor-pointer"
                            onClick={() => setPreviewImage(p.product_image)}
                          />
                        </td>
                        <td className="py-3 px-4 text-sm">{p.product_code}</td>
                        <td className="py-3 px-4 text-sm">{p.product_name}</td>
                        <td className="py-3 px-4 text-sm">{p.category_name}</td>
                        <td className="py-3 px-4 text-sm">{p.product_material}</td>
                        <td className="py-3 px-4 text-sm">{p.vendor_name || "Not assigned"}</td>
                        {/* <td className="py-3 px-4 text-sm">{p.product_status || "N/A"}</td> */}
                        <td className="py-3 px-4 text-sm">
                          <select
                            value={p.product_status}
                            onChange={(e) => updateProductStatus(p.product_code, e.target.value)}
                            className="border rounded px-2 py-1 text-sm bg-white hover:border-orange-400 focus:ring-1 focus:ring-orange-500"
                          >
                            {statusList.map((s) => (
                              <option key={s.id} value={s.product_status_name}>
                                {s.product_status_name}
                              </option>
                            ))}
                          </select>
                        </td>


                        <td className="py-3 px-4 text-sm">{p.product_cost_price || "N/A"}</td>
                        <td className="py-3 px-4 text-sm">{p.product_selling_price || "N/A"}</td>
                        <td className="py-3 px-4 text-sm">
                          {truncateWords(p.product_description, 10)}
                        </td>

                        <td className="py-3 px-4 text-sm">{p.added_by}</td>
                        <td className="py-3 px-4 text-sm">{formatDate(p.created_at)}</td>
                        <td className="py-3 px-4">
                          <button
                            onClick={() => {
                              setSelectedProductForVendor(p)
                              setIsAssignDialogOpen(true)
                            }}
                            className="px-2 py-1 border rounded text-white text-sm bg-orange-500 hover:bg-orange-600 transition-colors "
                          >
                            Assign/Change
                          </button>
                        </td>


                        <td className="py-3 px-4">
                          <div className="flex gap-2">
                            <button
                              onClick={() => {
                                setViewProduct(p);
                                setIsViewDialogOpen(true);
                              }}
                              className="p-1 text-gray-400 hover:text-blue-600 transition-colors"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                />
                              </svg>
                            </button>
                            <button
                              onClick={() => handleEditClick(p)}
                              className="p-1 text-gray-400 hover:text-blue-600 transition-colors"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                              </svg>
                            </button>

                            <button
                              onClick={() => handleDeleteClick(p)}
                              className="p-1 text-gray-400 hover:text-red-600 transition-colors"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                              </svg>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>

            {/* PAGINATION */}
            <div className="flex justify-between items-center mt-4 text-sm text-gray-600">
              <span>Page {currentPage} of {totalPages}</span>
              <div className="flex gap-2">
                <button
                  onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="px-3 py-1 border rounded-md disabled:opacity-50"
                >
                  Prev
                </button>
                <button
                  onClick={() => currentPage < totalPages && setCurrentPage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="px-3 py-1 border rounded-md disabled:opacity-50"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* IMAGE PREVIEW MODAL */}
        {previewImage && (
          <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50">
            <div className="bg-white p-4 rounded-lg max-w-2xl w-full relative">
              <button
                className="absolute top-3 right-3 text-gray-600 hover:text-black"
                onClick={() => setPreviewImage(null)}
              >
                ✖
              </button>

              <img src={previewImage} className="w-full object-contain max-h-[70vh]" />

              <div className="flex justify-end mt-4">
                <a
                  href={previewImage}
                  download
                  className="px-4 py-2 bg-orange-500 text-white rounded hover:bg-orange-600"
                >
                  Download
                </a>
              </div>
            </div>
          </div>
        )}

        {/* EDIT MODAL */}
        {isEditDialogOpen && editingProduct && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg w-full max-w-2xl relative max-h-[90vh] overflow-hidden">

              <div className="overflow-y-auto max-h-[90vh] p-6">
                <button
                  className="absolute top-3 right-4 text-gray-400 hover:text-gray-700 text-xl"
                  onClick={() => setIsEditDialogOpen(false)}
                >
                  ✖
                </button>

                <h2 className="text-lg font-semibold mb-4">Edit Product</h2>

                <form onSubmit={handleEditProduct} className="space-y-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Product Code</label>
                      <input
                        type="text"
                        value={editingProduct.product_code || ""}
                        disabled
                        className="w-full border rounded px-3 py-2 bg-gray-100 cursor-not-allowed"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Product Name</label>
                      <input
                        type="text"
                        value={editingProduct.product_name || ""}
                        onChange={(e) =>
                          setEditingProduct({ ...editingProduct, product_name: e.target.value })
                        }
                        className="w-full border rounded px-3 py-2"
                        required
                      />
                    </div>

                    {/* CATEGORY SEARCHABLE DROPDOWN */}
                    <div className="relative">
                      <label className="block text-sm font-medium text-gray-700 mb-1">Category</label>
                      <input
                        type="text"
                        value={editingProduct.category_name || ""}
                        onChange={(e) => {
                          setEditingProduct({ ...editingProduct, category_name: e.target.value })
                          setFilteredCategories(
                            categories.filter((c) =>
                              c.category_name.toLowerCase().includes(e.target.value.toLowerCase())
                            )
                          )
                          setShowCategoryDropdown(true)
                        }}
                        onFocus={() => setShowCategoryDropdown(true)}
                        onBlur={() => setTimeout(() => setShowCategoryDropdown(false), 200)}
                        className="w-full border rounded px-3 py-2"
                        required
                      />

                      {showCategoryDropdown && (
                        <ul className="absolute z-10 bg-white border border-gray-200 rounded-md shadow-md mt-1 w-full max-h-40 overflow-y-auto">
                          {filteredCategories.map((c) => (
                            <li
                              key={c.id}
                              onClick={() => {
                                setEditingProduct({ ...editingProduct, category_name: c.category_name })
                                setShowCategoryDropdown(false)
                              }}
                              className="px-4 py-2 hover:bg-orange-100 cursor-pointer text-sm"
                            >
                              {c.category_name}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>

                    {/* MATERIAL SEARCHABLE DROPDOWN */}
                    <div className="relative">
                      <label className="block text-sm font-medium text-gray-700 mb-1">Material</label>
                      <input
                        type="text"
                        value={editingProduct.product_material || ""}
                        onChange={(e) => {
                          setEditingProduct({ ...editingProduct, product_material: e.target.value })
                          setFilteredMaterials(
                            materials.filter((m) =>
                              m.product_material.toLowerCase().includes(e.target.value.toLowerCase())
                            )
                          )
                          setShowMaterialDropdown(true)
                        }}
                        onFocus={() => setShowMaterialDropdown(true)}
                        onBlur={() => setTimeout(() => setShowMaterialDropdown(false), 200)}
                        className="w-full border rounded px-3 py-2"
                        required
                      />

                      {showMaterialDropdown && (
                        <ul className="absolute z-10 bg-white border border-gray-200 rounded-md shadow-md mt-1 w-full max-h-40 overflow-y-auto">
                          {filteredMaterials.map((m) => (
                            <li
                              key={m.id}
                              onClick={() => {
                                setEditingProduct({ ...editingProduct, product_material: m.product_material })
                                setShowMaterialDropdown(false)
                              }}
                              className="px-4 py-2 hover:bg-orange-100 cursor-pointer text-sm"
                            >
                              {m.product_material}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>

                    {/* PRODUCT STATUS SEARCHABLE DROPDOWN */}

                    <div className="relative">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Product Status
                      </label>

                      <input
                        type="text"
                        value={editingProduct.product_status || ""}
                        onChange={(e) => {
                          setEditingProduct({
                            ...editingProduct,
                            product_status: e.target.value,
                          });

                          setFilteredStatusList(
                            statusList.filter((s) =>
                              s.product_status_name
                                .toLowerCase()
                                .includes(e.target.value.toLowerCase())
                            )
                          );

                          setShowStatusDropdown(true);
                        }}
                        onFocus={() => setShowStatusDropdown(true)}
                        onBlur={() => setTimeout(() => setShowStatusDropdown(false), 200)}
                        className="w-full border rounded px-3 py-2"
                        required
                      />

                      {/* Dropdown */}
                      {showStatusDropdown && (
                        <ul className="absolute z-10 bg-white border border-gray-200 rounded-md shadow-md mt-1 w-full max-h-40 overflow-y-auto">
                          {filteredStatusList.map((s) => (
                            <li
                              key={s.id}
                              onClick={() => {
                                setEditingProduct({
                                  ...editingProduct,
                                  product_status: s.product_status_name,
                                });
                                setShowStatusDropdown(false);
                              }}
                              className="px-4 py-2 hover:bg-orange-100 cursor-pointer text-sm"
                            >
                              {s.product_status_name}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>


                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Cost Price</label>
                      <input
                        type="text"
                        value={editingProduct.product_cost_price}
                        onChange={(e) =>
                          setEditingProduct({ ...editingProduct, product_cost_price: e.target.value })
                        }
                        className="w-full border rounded px-3 py-2"
                        required
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Selling Price</label>
                      <input
                        type="text"
                        value={editingProduct.product_selling_price}
                        onChange={(e) =>
                          setEditingProduct({ ...editingProduct, product_selling_price: e.target.value })
                        }
                        className="w-full border rounded px-3 py-2"
                        required
                      />
                    </div>

                    <div className="md:col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                      <textarea
                        value={editingProduct.product_description}
                        onChange={(e) =>
                          setEditingProduct({ ...editingProduct, product_description: e.target.value })
                        }
                        className="w-full border rounded px-3 py-2"
                        rows="2"
                      />
                    </div>

                    {/* IMAGE UPLOAD */}
                    <div className="md:col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-2">Product Image</label>
                      <div className="flex flex-col md:flex-row items-start gap-4">
                        {editingProduct.product_image && <img
                          src={
                            editingProduct.newImage
                              ? URL.createObjectURL(editingProduct.newImage)
                              : editingProduct.product_image
                          }
                          alt="Preview"
                          className="w-28 h-28 rounded object-cover border"
                        />}

                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e) =>
                            setEditingProduct({ ...editingProduct, newImage: e.target.files[0] })
                          }
                          className="text-sm"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-end gap-2 mt-4">
                    <button
                      type="button"
                      onClick={() => setIsEditDialogOpen(false)}
                      className="px-3 py-2 border rounded"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="px-4 py-2 bg-orange-500 hover:bg-orange-600 text-white rounded disabled:opacity-50"
                    >
                      {isSubmitting ? "Updating..." : "Update"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
        {isAssignDialogOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg w-full max-w-md p-6 relative">

              <button
                className="absolute top-3 right-4 text-gray-400 hover:text-gray-700 text-xl"
                onClick={() => setIsAssignDialogOpen(false)}
              >
                ✖
              </button>

              <h2 className="text-lg font-semibold mb-4">Assign Vendor</h2>

              <div className="relative">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Select Vendor
                </label>

                <input
                  value={vendorSearch}
                  type="text"
                  placeholder="Search vendor..."
                  onChange={(e) => {
                    const text = e.target.value;
                    setVendorSearch(text);

                    setFilteredVendors(
                      vendors.filter((v) =>
                        `${v.full_name} ${v.email}`
                          .toLowerCase()
                          .includes(text.toLowerCase())
                      )
                    );

                    setShowVendorDropdown(true);
                  }}
                  onFocus={() => setShowVendorDropdown(true)}
                  onBlur={() => setTimeout(() => setShowVendorDropdown(false), 200)}
                  className="w-full border rounded px-3 py-2"
                />


                {showVendorDropdown && (
                  <ul className="absolute z-10 bg-white border border-gray-200 rounded mt-1 w-full max-h-40 overflow-y-auto">
                    {filteredVendors.map((v, index) => (
                      <li
                        key={index}
                        onClick={() => {
                          setSelectedVendorEmail(v.email)
                          setVendorSearch(`${v.full_name} (${v.email})`);
                          setShowVendorDropdown(false)
                        }}
                        className="px-4 py-2 hover:bg-orange-100 cursor-pointer text-sm"
                      >
                        {v.full_name} ({v.email})
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              <button
                onClick={handleAssignVendor}
                className="mt-4 w-full bg-orange-500 text-white py-2 rounded hover:bg-orange-600"
              >
                Assign Vendor
              </button>

            </div>
          </div>
        )}
        {isViewDialogOpen && viewProduct && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg w-full max-w-2xl p-6 relative max-h-[90vh] overflow-y-auto">

              <button
                className="absolute top-3 right-4 text-gray-400 hover:text-gray-700 text-xl"
                onClick={() => setIsViewDialogOpen(false)}
              >
                ✖
              </button>

              <h2 className="text-xl font-semibold mb-4 text-gray-800">Product Details</h2>

              {/* IMAGE */}
              {viewProduct.product_image && (
                <img
                  src={viewProduct.product_image}
                  className="w-full max-h-72 object-contain rounded border mb-4"
                />
              )}

              {/* DETAILS */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-gray-700">
                <p><strong>Product Code:</strong> {viewProduct.product_code}</p>
                <p><strong>Product Name:</strong> {viewProduct.product_name}</p>
                <p><strong>Category:</strong> {viewProduct.category_name}</p>
                <p><strong>Material:</strong> {viewProduct.product_material}</p>
                <p><strong>Cost Price:</strong> {viewProduct.product_cost_price}</p>
                <p><strong>Selling Price:</strong> {viewProduct.product_selling_price}</p>
                <p><strong>Vendor:</strong> {viewProduct.vendor_name || "Not assigned"}</p>
                <p><strong>Added By:</strong> {viewProduct.added_by}</p>
                <p><strong>Created:</strong> {formatDate(viewProduct.created_at)}</p>
              </div>

              <p className="mt-4 text-gray-700 text-sm">
                <strong>Description:</strong> {viewProduct.product_description || "No description"}
              </p>

              <div className="flex justify-end mt-6">
                <button
                  onClick={() => setIsViewDialogOpen(false)}
                  className="px-4 py-2 bg-orange-500 hover:bg-orange-600 text-white rounded"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}


        <ConfirmationDialog
          isOpen={isDeleteDialogOpen}
          onClose={() => setIsDeleteDialogOpen(false)}
          onConfirm={handleDeleteProduct}
          title="Delete Product"
          message={`Are you sure you want to delete "${productToDelete?.product_name}"?`}
          confirmText="Delete"
          type="danger"
        />
      </div>
    </>
  )
}

export default ProductList

